<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-tag'></i> Tickets</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(Sno)="data">
                  {{data.index+1}}
                </template>
                <template v-slot:cell(Action)="data">
                  <b-btn v-if="checkAccessPrivilege('Lottery.Settings.Update')" variant="warning" class="btn-sm" @click="showUpdateModal(data.item)">Update</b-btn>
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <update-modal :show-modal="showModal" :update-data="updateData" @closeModal="closeUpdateModal"/>
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import UpdateModal from './Update'

export default {
  name: 'Lottery-setting-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showModal: false,
      items: [],
      fields: [
        {key: 'Sno', label: 'S.No'},
        {key: 'Label', label: 'Label'},
        {key: 'Value', label: 'Value'},
        {key: 'Comment', label: 'Description'},
        {key: 'Action', label: 'Action'}
      ],
      perPage: 50,
      currentPage: 1,
      updateData: {}
    }
  },
  watch: {
    currentPage: function (val) {
      this.search()
    }
  },
  components: {
    UpdateModal
  },
  methods: {
    getRowCount (item) {
      return item.length
    },
    async search () {
      try {
        Events.$emit('loader')
        let { data } = await this.$http.get(this.API_ENDPOINT + '/lottery/settings/list', { headers: { 'Content-Type': 'application/json' } })
        this.items = data
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    showUpdateModal (item) {
      this.showModal = true
      this.updateData = item
    },
    closeUpdateModal () {
      this.showModal = false
      this.updateData = {}
      this.search()
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    await this.search()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/lottery/settings/SettingsTable.vue